/**
 * 현재 페이지를 다시 불러온다 — 로그인 화면 우측 상단 새로고침 버튼이 쓴다.
 *
 * 한 줄짜리지만 모듈로 분리해 둔다. jsdom 은 window.location 재정의를 막아서,
 * 이 얇은 층이 없으면 "버튼을 누르면 실제로 새로고침되는가"를 테스트할 수 없다.
 */
export function reloadUi(): void {
  window.location.reload();
}
